import { CatHeading } from '@blocks-react/components/Heading';
import { FC } from 'react';

type LinkWithText = {
  text: string;
  link: string;
  linkText: string;
  className?: string;
};
export const PreferenceLink: FC<LinkWithText> = ({
  text,
  link,
  linkText,
  className = 'mt-2 mb-4'
}) => {
  return (
    <div className={className}>
      <CatHeading
        variant="footnote"
        data-testid="notification-preferences-text-link"
      >
        {' '}
        {text} <a href={link}>{linkText}</a>
      </CatHeading>
    </div>
  );
};
